import React, { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { apiV1 } from '../../../../../Auth/Interceptor';

function CategoryCollection({ item }) {
    const [productsList, setProductsList] = useState([]);

    useEffect(() => {
        async function fetchCollectionProducts() {
            try {
                const response = await apiV1.get(`collection/${item.item.categoryCollectionList[0]}`);
                if(response.status === 200) {
                    setProductsList(response.data.data.product);
                }
            }
            catch(err) {
                console.log(err);
            }
        }

        item.item.categoryCollectionList[0] && fetchCollectionProducts();
    }, [item]);

    return (
        <div className='px-3 flex flex-col gap-3'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[18px] leading-[30px] text-[#B0B0B0]'>{item.item.name}</p>

                <p className='font-semibold text-[14px] leading-[26px] text-[#64DD17]'>See all</p>
            </div>

            <div className="grid grid-cols-2 gap-x-3 gap-y-3">
                {productsList?.map(product => {
                    return (
                        <ProductCard 
                            key={product.id} 
                            product={product} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default CategoryCollection;
